/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesOrganizationMemberSchema } from "./organizationMemberSchema.ts";
import { goodLuckCoreEntitiesOrganizationRoleKeySchema } from "./organizationRoleKeySchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesOrganizationRoleSchema = z.object({
  id: z.optional(z.int()),
  name: z.string().min(1).max(50),
  get key() {
    return goodLuckCoreEntitiesOrganizationRoleKeySchema;
  },
  get organizationMembers() {
    return z.array(goodLuckCoreEntitiesOrganizationMemberSchema).nullish();
  },
});
